import React from 'react'
import ReactDOM from 'react-dom'
import Layout from '../components/layout'
import RaisedButton from 'material-ui/RaisedButton';
import {loadSecurityQuestions, registerUser} from '../store'
import Checkbox from 'material-ui/Checkbox';
import TextField from 'material-ui/TextField';
import {refreshActivityTimer} from '../components/timeout'
import PageviewGA from '../components/pageview-ga'

class Question extends React.Component {

    constructor() {
        super()
        this.state = ( {checked: false })
    }

    onCheck(e, c) {
        refreshActivityTimer()
        this.setState({checked: c})
        const answer = this.refs.answer.getValue()
        if(c) this.refs.answer.focus()
        this.props.onCheck(this.props.id, c, answer)

    }

    onAnswer() {
        refreshActivityTimer()
        const answer = this.refs.answer.getValue()

        let checked = true

        if ( answer === "") checked = false
        this.setState({checked})
        this.props.onCheck( this.props.id, checked, answer )
    }

    render() {

        return (
            <div className="question">
                <Checkbox label={this.props.text} checked={this.state.checked} onCheck={(e, c) => this.onCheck(e, c) }/>
                <TextField style={{width: "auto"}} className="padding inp-size" name={`question_${this.props.id}`} ref="answer" hintText="Answer" onChange={() => this.onAnswer()}/>
            </div>
        )
    }
}


class Body extends React.Component {

    constructor() {
        super();
        this.state = {pin1: "", pin2: "", pin: null, selected_questions: {}}
    }
    
    validatePin1Entry(e) {
        refreshActivityTimer()
        if ( isNaN(e.target.value) ) return
        let pin1 = e.target.value
        this.setState( {pin1, pin: null})
    }

    validatePin2Entry(e) {
        refreshActivityTimer()
        if ( isNaN(e.target.value) ) return
        let pin2 = e.target.value
        this.setState( {pin2, pin: null})
    }


    continue(e) {
        if (e) e.preventDefault()
        this.setState( {pin: this.state.pin1}  )

        //scroll to top of question list
        const myDiv = ReactDOM.findDOMNode(this).parentNode
        myDiv.scrollTop=0
    }

    componentDidMount() {
        this.refs.pin1.focus()
    }

    onQuestionChecked( id, checked, answer ) {
        let selectedQuestions = this.state.selected_questions
        delete selectedQuestions[id]
        if ( checked ) selectedQuestions[id] = answer
        this.setState( {selected_questions: selectedQuestions})
    }

    setupPin() {
        const pinsMatch = (this.state.pin1 === this.state.pin2) && this.state.pin1.length === 4
        const pinsDontMatch = (this.state.pin1 !== this.state.pin2) && this.state.pin1.length === 4 && this.state.pin2.length === 4

        return (
            <form>
                <div className="page-margin register-pin layout-row layout-align-center-start">
                    <div className="layout-column layout-align-center">

                        <h1>Please choose a PIN</h1>
                        <div>
                            <input name="pin1" ref="pin1" type="password" maxLength="4" minLength="4" size="4" value={this.state.pin1} onChange={(e) => this.validatePin1Entry(e)}/>
                        </div>

                        <h1>Please re-enter your PIN</h1>
                        <div>
                            <input name="pin2" ref="pin2" type="password" maxLength="4" minLength="4" size="4" value={this.state.pin2} onChange={(e) => this.validatePin2Entry(e)}/>
                        </div>
                        <br/>
                        { pinsDontMatch ?
                            <span className="error">The PINs must match</span>
                            : <br/>
                        }

                        <br/>
                        <RaisedButton disabled={!pinsMatch} fullWidth={true} label="CONTINUE" primary={true} onClick={() => this.continue()}/>
                    </div>
                </div>
            </form>
        )

    }

    setupQuestions() {

        let questions = this.props.store.security_questions.items.filter((q) => {
            if ( Object.keys(this.state.selected_questions).length === 3 ) {
                return( q.question_id in this.state.selected_questions )
            }
            else return true
        }).map( (q) => {
            return (
                <Question key={q.question_id} text={q.question_text} id={q.question_id}
                          onCheck={(id,c, answer) => this.onQuestionChecked(id,c, answer)}/>
            )
        })

        const allAnswered = Object.keys(this.state.selected_questions).filter( (id) => {
                return this.state.selected_questions[id] !== ""
            } ).length === 3

        return (
            <div>
                <div className="page-margin register-questions layout-row layout-align-center-start">
                    <div className="layout-column layout-align-center">
                        <h1>Choose 3 security questions</h1>
                        <div>
                            {questions}
                        </div>
                        <br/>
                        <RaisedButton id="complete_and_login" disabled={!allAnswered} fullWidth={true} label="COMPLETE AND LOGIN" primary={true} onClick={() => this.completeAndLogin()}/>
                        <br/>
                    </div>
                </div>
            </div>

        )

    }

    completeAndLogin() {
        registerUser(this.state.pin, this.state.selected_questions)
    }

    render() {
        if ( !this.state.pin ) {
            return this.setupPin()
        }
        else {
            return this.setupQuestions()
        }
    }
}



export default class extends React.Component {

    componentDidMount() {
        loadSecurityQuestions()
    }

    render() {
        let sp = this.props.store.security_questions.show_spinner || this.props.store.register.show_spinner
        let errorMessage = null
        if( this.props.store.register.treat_as_error ) errorMessage = "Unable to register"
        if( this.props.store.security_questions.treat_as_error ) errorMessage = "Error retrieving security questions"

        return (
            <div className="layout-row flex">
                <PageviewGA/>
                <Layout title="Registration"
                        showAppBarActions={false}
                        {...this.props}
                        ready={ !sp }
                        errorMessage={errorMessage}
                        body={Body}>
                </Layout>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/pages/register.js